/**
 * Adds unique elements from the childArray to the parentArray.
 *
 * This function iterates through each element of childArray and adds it to parentArray
 * only if it does not already exist in parentArray, based on a specified identifier.
 * The uniqueness of elements is determined by the value of the property denoted by
 * the 'identifier' in each element.
 *
 * @param {Array} parentArray - The array to which elements will be added.
 * @param {Array} childArray - The array containing elements to be potentially added to parentArray.
 * @param {string} identifier - The property name used to determine the uniqueness of elements.
 *
 * @returns {Array} A new array composed of elements from parentArray plus unique elements from childArray.
 *
 * Usage Example:
 *   const parent = [{ id: 1, name: 'Apple' }, { id: 2, name: 'Banana' }];
 *   const children = [{ id: 2, name: 'Banana' }, { id: 3, name: 'Cherry' }];
 *   const result = addToArray(parent, children, 'id');
 *   // result will be [{ id: 1, name: 'Apple' }, { id: 2, name: 'Banana' }, { id: 3, name: 'Cherry' }]
 */
export const addToArray = (parentArray, childArray, identifier) => {
  const existingIds = new Set(parentArray.map((item) => item[identifier]));
  const newArray = childArray.filter(
    (child) => !existingIds.has(child[identifier])
  );
  return [...parentArray, ...newArray];
};
